import PictureListItem from '../../organisms/events/PictureListItem';
import React, { Fragment } from 'react';
import BasicEventListItem from '../../organisms/events/BasicListItem';
import PageSeparator from './PageSeparator';
import { useInView } from 'react-intersection-observer';
import { useTracking } from '../../../contexts/trackingContext';

const ListItem = ({
  event,
  isBackfill,
  isFeatured,
  isEditorsPick,
  extraClasses,
  position,
  displayImagesOnBackfill,
  viewedFrom,
}) => {
  const { tracker } = useTracking();
  const { ref } = useInView({
    triggerOnce: true,
    onChange: (inView) => {
      if (inView) {
        tracker.trackEventView(event, viewedFrom);
      }
    },
  });
  const pageSeparator = position && position.index === 0 && (
    <PageSeparator pageNumber={position.pageNumber} />
  );

  const backfillItem = displayImagesOnBackfill ? (
    <PictureListItem event={event} extraClasses={extraClasses} itemRef={ref}>
      {pageSeparator}
    </PictureListItem>
  ) : (
    <BasicEventListItem event={event} extraClasses={extraClasses} itemRef={ref}>
      {pageSeparator}
    </BasicEventListItem>
  );

  return (
    <Fragment>
      {isBackfill && backfillItem}
      {!isBackfill && (
        <PictureListItem
          key={event.id}
          event={event}
          isFeatured={isFeatured}
          isEditorsPick={isEditorsPick}
          extraClasses={extraClasses}
          itemRef={ref}
        >
          {pageSeparator}
        </PictureListItem>
      )}
    </Fragment>
  );
};

export default ListItem;
